module.exports = __webpack_public_path__ + "static/media/bose-nc-700.b7037a4a.png";